exports.getUrlFriendlyAwardType = (type) => {
  switch (type) {
    case 'isp':
      return 'fixed';
    case 'carrier':
      return 'mobile';
    case 'best':
      return 'best';
    case 'coverage':
      return 'coverage';
    case 'top_rated_carrier':
      return 'top-rated-mobile';
    case 'top_rated_provider':
      return 'top-rated-fixed';
    case 'best_mobile':
      return 'best-mobile';
    case 'best_fixed':
      return 'best-fixed';
    case '5g':
      return 'fastest-5g';
    case '5g_video_experience':
      return '5g-video-experience';
    case 'best_mobile_video_experience':
      return 'best-mobile-video-experience';
    case 'best_isp_video_experience':
      return 'best-isp-video-experience';
    case 'best_5g_gaming_experience':
      return 'best-5g-gaming-experience';
    case 'best_mobile_gaming_experience':
      return 'best-mobile-gaming-experience';
    case 'best_isp_gaming_experience':
      return 'best-isp-gaming-experience';
    case 'best_5g':
      return 'best-5g';
    default:
      throw new Error('award type must be either `isp`, `carrier`, `top_rated_carrier`, `best_mobile`, `best_fixed`, `5g`, `5g_video_experience`, `best_isp_video_experience`, or `best_mobile_video_experience`, `best_5g_gaming_experience`, `best_mobile_gaming_experience, `best_isp_gaming_experience`, `best_5g`');
  }
};
